<template lang="pug">
  div
    apexchart(
      :type="isDonut ? 'donut':'pie'"
      :options="chartOptions"
      :series="series"
      @click=""
      )
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'c_chart_line',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    yAxisTitle: {
      type: String,
      default: 'Valor y'
    },
    xAxisTitle: {
      type: String,
      default: 'Valor x'
    },
    tooltipFormatter: {
      type: Function,
      default: (val) => `${val}`
    },
    title: {
      type: String,
      default: 'El titulo'
    },
    isDonut: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          height: 350
        },
        theme: {
          palette: 'palette1'
        },
        title: {
          text: this.title
        },
        subtitle:{
          text: this.subtitle
        },
        labels: this.categories
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
  div
    width 100%
    height 100%
    max-width 800px
    margin 0 auto
    padding 20px
    box-sizing border-box
</style>




// WEBPACK FOOTER //
// c_chart_pie.vue?2ea42b78